// src/components/seo/ArticleSchema.tsx
import React from 'react';
import { jsonLdHtml } from '@/lib/seo/jsonLd';

export interface ArticleSchemaProps {
  headline: string;
  description?: string;
  datePublished: string;
  dateModified?: string;
  author: {
    name: string;
    url?: string;
  };
  image?: string;
  url: string;
  keywords?: string[];
  articleSection?: string;
}

export default function ArticleSchema(props: ArticleSchemaProps) {
  const schema = {
    '@context': 'https://schema.org',
    '@type': 'Article',
    headline: props.headline,
    description: props.description,
    datePublished: props.datePublished,
    dateModified: props.dateModified || props.datePublished,
    author: {
      '@type': 'Person',
      name: props.author.name,
      url: props.author.url,
    },
    publisher: {
      '@type': 'Organization',
      name: 'JuicyStarz',
      url: 'https://juicystarz.com',
      logo: {
        '@type': 'ImageObject',
        url: 'https://juicystarz.com/img/JuicyStarz.png',
      },
    },
    mainEntityOfPage: {
      '@type': 'WebPage',
      '@id': props.url,
    },
    ...(props.image && {
      image: {
        '@type': 'ImageObject',
        url: props.image,
      },
    }),
    ...(props.keywords && props.keywords.length > 0 && {
      keywords: props.keywords.join(', '),
    }),
    ...(props.articleSection && {
      articleSection: props.articleSection,
    }),
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: jsonLdHtml(schema) }}
    />
  );
}
